import api from './api';

/**
 * Get the customer infos.
 * @param {string} id
 * @returns {Promise<import('axios').AxiosResponse<Customer>>}
 */
export const getCustomer = async (id) => api.get('/customer', { params: { id } });
